import { AreaLayoutCore } from "../database/manualLayoutData";
import { CourseData } from "../datastructures/coursedata";
import { ICourseNode } from "../datastructures/dataviz";

//TODO: Set default position to center of homeArea cluster? May make for better initial animation

export const ProcessCourseDataMapToNodes = (
  CourseDataMap: CourseData[]
): ICourseNode[] => {
  let ret: ICourseNode[] = [];
  // console.log("hi")
  CourseDataMap.forEach((courseData) => {
    let node: any = {};
    // let areas = courseData.courseAreas
    node.data = courseData;
    // Ensure courseAreas is a valid array; default to area 0 if missing/empty
    const areas = Array.isArray(courseData.courseAreas)
      ? courseData.courseAreas
      : [];
    const homeArea = areas.length > 0 ? areas[0] : 0;
    if (AreaLayoutCore[homeArea] !== undefined) {
      node.position = {
        x: AreaLayoutCore[homeArea].x,
        y: AreaLayoutCore[homeArea].y,
      };
    } else {
      node.position = { x: 0, y: 0 }; // fallback
    }
    node.hidden = true;
    node.stylemode = GenerateClassNameByAreas(courseData);
    node.homeArea = homeArea;
    // node.homeArea = courseData.courseAreas[0]
    ret.push(node);
  });
  return ret;
};

export const GenerateClassNameByAreas = (data) => {
  let styleBundle = "";
  let areas = Array.isArray(data.courseAreas) ? data.courseAreas : [];
  if (areas.length === 0) return "area-0";
  for (var i = 0; i < areas.length - 1; i++) {
    styleBundle += "area-" + areas[i] + "-and-";
  }
  styleBundle += "area-" + areas[areas.length - 1]; //append last el
  return styleBundle;
};
